var u = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/, f = /\/assets\/([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})\/file$/i;
function n(e) {
  if (typeof e != "string" || e === "") return null;
  let t;
  try {
    t = new URL(e);
  } catch {
    return null;
  }
  return t.protocol !== "http:" && t.protocol !== "https:" || !t.hostname ? null : t;
}
function o(e) {
  return e.pathname.replace(/\/+$/, "");
}
function c(e, t) {
  const r = n(e);
  if (!r) return null;
  const s = n(t);
  if (!s || r.origin !== s.origin || r.search !== "" || r.hash !== "") return null;
  const l = o(s);
  if (l && !r.pathname.toLowerCase().startsWith(`${l.toLowerCase()}/`)) return null;
  const i = r.pathname.slice(l.length), a = /^\/assets\/([^/]+)\/file$/i.exec(i);
  return !a || !u.test(a[1]) ? null : a[1].toLowerCase();
}
function h(e, t) {
  return c(e, t) !== null;
}
function F(e, t) {
  const r = n(e);
  if (!r) throw new Error(`assetFileUrl: apiBase must be an absolute http(s) URL, got "${e}"`);
  if (!u.test(t)) throw new Error(`assetFileUrl: assetId must be a guid, got "${t}"`);
  return `${r.origin}${o(r)}/assets/${t.toLowerCase()}/file`;
}
function p(e) {
  const t = n(e);
  if (!t || t.search !== "" || t.hash !== "") return null;
  const r = f.exec(t.pathname);
  return r ? r[1].toLowerCase() : null;
}
export {
  c as i,
  h as n,
  p as r,
  F as t
};

//# sourceMappingURL=assetRef-BeDJZkjy.js.map